import { FileValidationErrorCode, FileValidationResult } from '../healthPlan/utils/healthPlanCardValidation'

export const DOCUMENT_UPLOAD_MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB in bytes
export const DOCUMENT_UPLOAD_MAX_FILE_NAME_LENGTH = 50

const DOCUMENT_UPLOAD_SUPPORTED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
] as const

const DOCUMENT_UPLOAD_SUPPORTED_FILE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.pdf', '.docx'] as const

/**
 * Ensures file size and file type are valid for document upload
 * Supported formats: JPEG, PNG, PDF, and DOCX. Max file size: 10MB
 */
export const validateDocumentFile = (file: File | null | undefined): FileValidationResult => {
  if (!file) {
    return {
      isValid: false,
      error: {
        code: FileValidationErrorCode.NO_FILE_PROVIDED,
      },
    }
  }

  if (file.size > DOCUMENT_UPLOAD_MAX_FILE_SIZE) {
    return {
      isValid: false,
      error: {
        code: FileValidationErrorCode.FILE_TOO_LARGE,
      },
    }
  }

  const isValidType = DOCUMENT_UPLOAD_SUPPORTED_FILE_TYPES.includes(
    file.type as (typeof DOCUMENT_UPLOAD_SUPPORTED_FILE_TYPES)[number],
  )

  // Check file extension as a fallback
  const fileName = file.name.toLowerCase()
  const hasValidExtension = DOCUMENT_UPLOAD_SUPPORTED_FILE_EXTENSIONS.some((ext) => fileName.endsWith(ext))

  if (!isValidType && !hasValidExtension) {
    return {
      isValid: false,
      error: {
        code: FileValidationErrorCode.UNSUPPORTED_FILE_TYPE,
      },
    }
  }

  return {
    isValid: true,
  }
}
